export const LANGUAGES = {
  es: "Español",
  en: "English",
}
